/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Day_FreeInputs */

const en_plan_day_free = /** @type {(inputs: Plan_Day_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to cook`)
};

const de_plan_day_free = /** @type {(inputs: Plan_Day_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts zu kochen`)
};

/**
* | output |
* | --- |
* | "Nothing to cook" |
*
* @param {Plan_Day_FreeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_day_free = /** @type {((inputs?: Plan_Day_FreeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Day_FreeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_day_free(inputs)
	return en_plan_day_free(inputs)
});